import { APIService } from "../../../../network/api/APIService";

export const ArticleData = (app_id, slug) => {
    const endpoint = `/app/article/?app_id=${app_id}&slug=${slug}`

    return APIService({
        endpoint: endpoint,
        method: "GET",
        credentials: "include"
    });
};